import type { Action, Field, Form } from '@jmvdevelop/svelte-form';
import { safe } from '$lib/utils/string';
import { addFieldOrRootError } from '$lib/validator/validatorUtils.js';

export function isBetween<TValues, TValue>(
    value: number,
    {
        form,
        field,
        min,
        max,
        messageValueIsLowerThanMin,
        messageValueIsGreaterThanMax,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TValue>; // eslint-disable-line @typescript-eslint/no-explicit-any
        min: number;
        max: number;
        messageValueIsLowerThanMin: string;
        messageValueIsGreaterThanMax: string;
    },
): Action<TValues, string> {
    if (value < min) {
        return addFieldOrRootError(form, field, messageValueIsLowerThanMin);
    }
    if (value > max) {
        return addFieldOrRootError(form, field, messageValueIsGreaterThanMax);
    }
    return (s) => s;
}

export function lengthIsBetween<TValues, TValue>(
    value: ArrayLike<unknown> | string | null,
    {
        form,
        field,
        min,
        max,
        messageValueIsLowerThanMin,
        messageValueIsGreaterThanMax,
    }: {
        form: Form<TValues, string>;
        field?: Field<TValues, TValue>;
        min?: number | null;
        max?: number | null;
        messageValueIsLowerThanMin?: string | null;
        messageValueIsGreaterThanMax?: string | null;
    },
): Action<TValues, string> {
    if (value == null) {
        return (s) => s;
    }

    const length = value.length;

    if (min != null && length < min) {
        return addFieldOrRootError(
            form,
            field,
            messageValueIsLowerThanMin ??
                safe`Cette chaîne est trop courte. Elle doit avoir au minimum ${min} caractères.`,
        );
    }

    if (max != null && length > max) {
        return addFieldOrRootError(
            form,
            field,
            messageValueIsGreaterThanMax ??
                safe`Cette chaîne est trop longue. Elle doit avoir au maximum ${max} caractères.`,
        );
    }

    return (s) => s;
}
